import "./index.css";
import React from "react";
import Select, { components } from "react-select";
import { selectStyles } from "../../screens/ProductPortfolio/components/PortfolioModal/utils";

export default function Dropdown({
  onClick,
  options,
  hex,
  white,
  id,
  value = null,
}) {
  const styles = selectStyles(hex, white);

  const onChange = (option) => {
    onClick && onClick(option);
  };

  const CustomSingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        {props.data.label}
      </components.SingleValue>
    );
  };

  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <span>{props.data.label}</span>
        {props.data.isDefault && (
          <span className="custom-dropdown__default-label">
            Default category
          </span>
        )}
      </components.Option>
    );
  };

  return (
    <Select
      id={id}
      placeholder="Select an option"
      value={value}
      onChange={onChange}
      options={options || []}
      styles={styles}
      menuPlacement="bottom"
      components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js